import { render, staticRenderFns } from "./SectionNosotros4.vue?vue&type=template&id=ff8426b8&scoped=true&"
import script from "./SectionNosotros4.vue?vue&type=script&lang=js&"
export * from "./SectionNosotros4.vue?vue&type=script&lang=js&"
import style0 from "./SectionNosotros4.vue?vue&type=style&index=0&id=ff8426b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8426b8",
  null
  
)

export default component.exports